import React, { useRef, useState } from "react";
import { ManualBox } from "../manualsBox/products-manualsBox";
export const tabList = [
    {idx: 1, title : 'Features'},
    {idx: 2, title : 'Description'},
    {idx: 4, title : 'Specifications'},
    {idx: 5, title : 'Manuals & Firmware'},
]
export const GX11004K = () => {
    const [state, setState] = useState<any>({first : 1, second : 1})
    const [tabIndex, setTabIndex] = useState<number>(1)
    const scrollRef = [
        useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null)
    ];
    const handleScroll = (ref : number) => {
        if(scrollRef[ref] && scrollRef[ref].current){
            scrollRef[ref].current.scrollIntoView({
                behavior : 'smooth'
            })
        }
    }
    return(
        <>
        <div className="product_view gx11004k">
            <div className="bgBox" style={{backgroundImage: "url('/assets/images/banner_GX11004k.png')"}}>
                <div className="centerBox">
                    <h2><span>GX1100</span> 4k</h2>
                    <p>4K Clear View Dash cam wIth Auto Connection</p>
                    <ul>
                        <li onClick={() => handleScroll(0)}>UHD/FHD</li>
                        <li onClick={() => handleScroll(1)}>SONY STARVIS SENSOR</li>
                        <li onClick={() => handleScroll(2)}>AUTO NIGHT VISION</li>
                        <li onClick={() => handleScroll(3)}>ADAS PLUS</li>
                        <li onClick={() => handleScroll(4)}>TIME LAPSE</li>
                        <li onClick={() => handleScroll(5)}>SPEED CAMERA ALERT</li>
                        <li onClick={() => handleScroll(6)}>NON-LCD</li>
                        <li onClick={() => handleScroll(7)}>POWER SAVING PARKING MODE</li>
                        <li onClick={() => handleScroll(8)}>BUILT-IN GPS & WI-FI</li>
                        <li onClick={() => handleScroll(9)}>FINEVU CLOUD & WI-FI APP</li>
                        <li onClick={() => handleScroll(10)}>AI HEAT MONITORING</li>
                        <li onClick={() => handleScroll(11)}>LOW VOLTAGE CUT-OFF</li>
                        <li onClick={() => handleScroll(12)}>MEMORY ALLOCATION</li>
                        <li onClick={() => handleScroll(13)}>CUSTOMIZING OSD PHRASES</li>
                        <li onClick={() => handleScroll(14)}>FORMAT FREE 2.0</li>
                    </ul>
                </div>

                <div className="scrollDownBox">
                    <div>
                        <span></span>
                    </div>
                    <span>SCROLL</span>
                </div>
            </div>
            {/* <!-- bgBox Fin --> */}

            <div className="tabWrap tabBtnWrapBattery">
                <div className="tabBtnWrap">
                    <div className="tabBtnBox">
                        {tabList.map((list: { idx: number, title: string }) => (

                          <button className={tabIndex === list?.idx ? 'active' : ''} onClick={() => setTabIndex(list?.idx)}>
                              {list?.title}
                          </button>
                        ))}
                    </div>
                </div>
                <div className="tabContentBox">
                    <div className={`features ${tabIndex === 1 ? 'active' : ''}`}>
                        <div className="sliderWrap">
                            <ul>
                                <li>
                                    <div className="imgBox">
                                        <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_01.png" alt="GX10004K"/>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div className="iconBox2">
                            <ul>
                                <li>
                                    <div>
                                        <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_02.png" alt="UHD/FHD"/>
                                    </div>
                                    <span>UHD/FHD</span>
                                </li>
                                <li>
                                    <div>
                                        <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_03.png" alt="SONY STARVIS Sensor"/>
                                    </div>
                                    <span>
                                    SONY STARVIS<br/>
                                    Sensor
                                </span>
                                </li>
                                <li>
                                    <div>
                                        <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_04.png" alt="Auto Night Vision"/>
                                    </div>
                                    <span>
                                    Auto<br/>
                                    Night Vision
                                </span>
                                </li>
                                <li>
                                    <div>
                                        <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_05.png" alt="ADAS PLUS"/>
                                    </div>
                                    <span>
                                    ADAS PLUS
                                </span>
                                </li>
                                <li>
                                    <div>
                                        <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_06.png" alt="TIME LAPSE"/>
                                    </div>
                                    <span>
                                    TIME LAPSE
                                </span>
                                </li>
                                <li>
                                    <div>
                                        <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_07.png" alt="SPEED CAMERA ALERT"/>
                                    </div>
                                    <span>SPEED CAMERA<br/> ALERT</span>
                                </li>
                                <li>
                                    <div>
                                        <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_08.png" alt="NON-LCD"/>
                                    </div>
                                    <span>
                                    NON-LCD
                                </span>
                                </li>
                                <li>
                                    <div>
                                        <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_09.png" alt="POWER SAVING PARKING MODE"/>
                                    </div>
                                    <span>
                                    POWER SAVING<br/>
                                    PARKING MODE
                                </span>
                                </li>
                                <li>
                                    <div>
                                        <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_10.png" alt="BUILT-IN GPS & WI-FI"/>
                                    </div>
                                    <span>
                                    BUILT-IN<br/> GPS & WI-FI
                                </span>
                                </li>
                                <li>
                                    <div>
                                        <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_11.png" alt="FINEVU CLOUD & WI-FI APP"/>
                                    </div>
                                    <span>
                                    FINEVU CLOUD<br/> & WI-FI APP
                                </span>
                                </li>
                                <li>
                                    <div>
                                        <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_12.png" alt="AI HEAT MONITORING"/>
                                    </div>
                                    <span>AI HEAT <br/> MONITORING</span>
                                </li>
                                <li>
                                    <div>
                                        <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_13.png" alt="LOW VOLTAGE CUT-OFF"/>
                                    </div>
                                    <span>
                                    LOW VOLTAGE<br/> CUT-OFF
                                </span>
                                </li>
                                <li>
                                    <div>
                                        <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_14.png" alt="MEMORY ALLOCATION"/>
                                    </div>
                                    <span>
                                    MEMORY <br/>ALLOCATION
                                </span>
                                </li>
                                <li>
                                    <div>
                                        <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_15.png" alt="CUSTOMIZING OSD PHRASES"/>
                                    </div>
                                    <span>
                                    CUSTOMIZING OSD<br/> PHRASES
                                </span>
                                </li>
                                <li>
                                    <div>
                                        <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_16.png" alt="FORMAT FREE 2.0"/>
                                    </div>
                                    <span>
                                    FORMAT <br/>FREE 2.0
                                </span>
                                </li>
                            </ul>
                        </div>

                        <div className="imgBox" ref={scrollRef[0]}>
                            <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_17.png" alt="product view"/>
                        </div>

                        <div className="resolution_tableWrap">
                            <ul>
                                <li>
                                    <span>Definition</span>
                                    <span>FULL HD</span>
                                    <span>UHD</span>
                                </li>
                                <li>
                                    <span>Resolution</span>
                                    <span>1920 × 1080</span>
                                    <span>3840 × 2160</span>
                                </li>
                                <li>
                                    <span>Pixels</span>
                                    <span>2,073,600</span>
                                    <span>8,294,400</span>
                                </li>
                            </ul>
                        </div>

                        <section className="section_1">
                            <h3>
                                <span>CRYSTAL CLEAR UHD RESOLUTION</span>
                                UHD CAPTURES EVERY MOMENT REALISTICALLY
                            </h3>

                            <div className="slide_tabBtnWrap">
                                <div className={`slide_tabBtnBox number2 active_${state.first}`}>
                                    <button onClick={() => setState((prev: any) => ({...prev, first: 1}))}>
                                        <span>Day</span>
                                    </button>
                                    <button onClick={() => setState((prev: any) => ({...prev, first: 2}))}>
                                        <span>Night</span>
                                    </button>
                                </div>
                            </div>

                            <div className="tabContentBox">
                                <div className={state.first === 1 ? 'active' : ''}>
                                    <div className="imgBox">
                                        <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_18.png" alt="front day"/>
                                    </div>
                                </div>
                                <div className={state.first === 2 ? 'active' : ''}>
                                    <div className="imgBox">
                                        <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_19.png" alt="night"/>
                                    </div>
                                </div>
                            </div>

                            <p>* This photo was taken in QHD quality. The license plate is blurred to protect personal information.</p>
                            <p>* The quality of recording may vary depending on conditions. (including camera angle, windshield conditions, and light conditions)</p>
                        </section>

                        <section className="section_2" ref={scrollRef[1]}>
                            <h3>
                                <span>SONY STARVIS SENSOR</span>
                                CLEAR RECORDING EVEN AT NIGHT
                            </h3>
                            <p>SONY STARVIS SENSOR provides unimaginably vivid image in regardless of day or night.</p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_20.png" alt="CLEAR RECORDING EVEN AT NIGHT"/>
                            </div>
                        </section>

                        <section className="section_3" ref={scrollRef[2]}>
                            <h3>
                                <span>AUTO NIGHT VISION</span>
                                AUTOMATED NIGHT VISION ADJUSTS<br/>
                                BRIGHTNESS AND CONTRAST TO SECURE CLARITY
                            </h3>
                            <p>
                                Smart AI system assesses light environment and finds the perfect time to switch it on.<br/>
                                Keeping you completely hand-free.
                            </p>

                            <div className="slide_tabBtnWrap">
                                <div className={`slide_tabBtnBox number2 active_${state.second}`}>
                                    <button onClick={() => setState((prev: any) => ({...prev, second: 1}))}>
                                        <span>Night</span>
                                    </button>
                                    <button onClick={() => setState((prev: any) => ({...prev, second: 2}))}>
                                        <span>Day</span>
                                    </button>
                                </div>
                            </div>

                            <div className="tabContentBox">
                                <div className={state.second === 1 ? 'active' : ''}>
                                    <div className="imgBox">
                                        <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_21.png" alt="night"/>
                                    </div>
                                </div>
                                <div className={state.second === 2 ? 'active' : ''}>
                                    <div className="imgBox">
                                        <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_22.png" alt="day"/>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section className="section_4" ref={scrollRef[3]}>
                            <h3>
                                <span>ADAS PLUS</span>
                                ADVANCED DRIVER SAFETY WARNING SYSTEMS<br/>
                                KEEP YOU SAFE ON THE ROAD
                            </h3>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_23.png" alt="ADAS PLUS"/>
                            </div>
                        </section>

                        <section className="section_5">
                            <h3>
                                LANE DEPARTURE WARNING SYSTEM (LDWS)
                            </h3>
                            <p>
                                Alert if triggered as vehicle veers off driving lane while in motion.
                            </p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_24.png" alt="LDWS"/>
                            </div>
                        </section>

                        <section className="section_6">
                            <h3>
                                FRONT VEHICLE MOTION ALERT (FVMA)
                            </h3>
                            <p>
                                While stopped in traffic, the movement of stationary vehicle ahead triggers alert to driver.
                            </p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_25.png" alt="FVMA"/>
                            </div>
                        </section>

                        <section className="section_7" ref={scrollRef[4]}>
                            <h3>
                                <span>time-lapse</span>
                                RECORD YOUR DRIVE WITH TIME-LAPSE
                            </h3>
                            <p>
                                TIME-LAPSE feature capture up to 743 minutes with no data loss.
                            </p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_26.png" alt="TIME Lapse"/>
                            </div>
                            <ul>
                                <li>* TIME-LAPSE Specifications were measured under 32GB and compared to the default driving mode.</li>
                                <li>* Factors such as collision events may affect the storage volume.</li>
                            </ul>
                        </section>

                        <section className="section_9" ref={scrollRef[5]}>
                            <h3>
                                <span>speed camera alert</span>
                                FINEVU KEEPS UP WITH THE<br/>
                                LATEST SAFETY CAMERA ALERT
                            </h3>
                            <p>
                                FineVu safety camera database is always up to date. Download the quarterly updates,<br/>
                                and get informed with FineVu’s voice alerts.<br/>
                                Worry no more about accidents and speeding tickets.
                            </p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_27.png" alt="speed camera alert"/>
                            </div>
                            <ul>
                                <li>* Database is updated quarterly.</li>
                            </ul>
                        </section>

                        <section className="section_10" ref={scrollRef[6]}>
                            <h3>
                                <span>non-lcd</span>
                                COMPACT SIZE, UNOBSTRUCTED VIEW,<br/>
                                READY FOR ANY ROAD
                            </h3>
                            <p>
                                With FineVu compact design, easily mount anywhere without blocking your rearview mirror.
                                Quick and simple installation in the perfect position for you.
                            </p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_28.png" alt="NON-LCD"/>
                            </div>
                        </section>

                        <section className="section_11" ref={scrollRef[7]}>
                            <h3>
                                <span>POWER SAVING PARKING MODE</span>
                                PROLONGED RECORDING TIME
                            </h3>
                            <p>
                                Consuming 98% less power, GX1100 4K records 2,325 more hours than standard parking mode.
                            </p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_29.png" alt="POWER SAVING PARKING MODE"/>
                            </div>
                        </section>

                        <section className="section_12" ref={scrollRef[8]}>
                            <h3>
                                <span>built-in gps</span>
                                WITHOUT THE BURDEN OF PURCHASING<br/>
                                ADDITIONAL EXTERNAL GPS
                            </h3>
                            <p>
                                Consuming 98% less power, GX1100 4K records 2,325 more hours than standard parking mode.
                            </p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_30.png" alt="built-in gps"/>
                            </div>
                        </section>

                        <section className="section_13" ref={scrollRef[9]}>
                            <h3>
                                <span>built-in bt + WI-FI</span>
                                SEAMLESSLY CONNECT TO<br/>
                                YOUR SMARTPHONE ON THE FIRST TRY
                            </h3>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_31.png" alt="built-in bt + WI-FI"/>
                            </div>
                            <ul>
                                <li>* If the connection fails, please allow all FineVU CLOUD & Wi-Fi app permissions.</li>
                            </ul>
                        </section>

                        <div className="resolution_tableWrap">
                            <ul>
                                <li>
                                    <span></span>
                                    <span>Wi-Fi</span>
                                    <span>BT + Wi-Fi</span>
                                </li>
                                <li>
                                    <span>DAY 1<br/><span style={{fontSize: '14px', color: '#666'}}>First Connection</span></span>
                                    <span><img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_32.png" alt="WI-FI"/></span>
                                    <span style={{borderBottom: '1px solid #F0800E'}}><img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_33.png" alt="built-in bt + WI-FI"/></span>
                                </li>
                                <li>
                                    <span>DAY 2</span>
                                    <span><img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_34.png" alt="WI-FI"/></span>
                                    <span style={{borderRight: '1px solid #F0800E', borderBottom: '1px solid #F0800E'}}><img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_35.png" alt="built-in bt + WI-FI"/></span>
                                </li>
                                <li>
                                    <span>DAY 3</span>
                                    <span><img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_36.png" alt="WI-FI"/></span>
                                    <span><img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_37.png" alt="built-in bt + WI-FI"/></span>
                                </li>
                            </ul>
                        </div>

                        <section className="section_14">
                            <h3>
                                CHECK THE RECORDED VIDEOS AND UPDATE<br/>
                                THE FIRMWARE ON FINEVE APP.
                            </h3>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_38.png" alt="APP"/>
                            </div>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_39.png" alt="APP QR Code"/>
                            </div>
                        </section>

                        <section className="section_15">
                            <h3>
                                BLAZING-FAST, STABLE<br/>
                                5GHZ WI-FI CONNECTION
                            </h3>
                            <p>Optimized for in-vehicle environments, this dashcam supports 5GHz Wi-Fi settings.<br/>
                                Quickly save recorded footage directly to your smartphone<br/>
                                at high speeds — no delays, no hassle.</p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_40.png" alt="BLAZING-FAST"/>
                            </div>
                            <ul style={{marginTop: '30px'}}>
                                <li>* For smartphones that do not support 5GHz Wi-Fi, please change the Wi-Fi setting in the dashcam menu to 2.4GHz Wi-Fi</li>
                            </ul>
                        </section>

                        <section className="section_16" ref={scrollRef[10]}>
                            <h3>
                                <span>Ai heat monitoring</span>
                                SMART AI DASHCAM CONTROL
                            </h3>
                            <p>If FineVu starts to overheat while at parking mode, the AI will automatically switch it to Power Saving Parking Mode.<br/>
                                When it cools down and temperature stabilizes, AI will switch it back to motion parking mode.</p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_41.png" alt="Ai heat monitoring"/>
                            </div>
                            <ul style={{marginTop: '30px'}}>
                                <li>* The feature is only applicable during motion/time lapse parking mode.</li>
                            </ul>
                        </section>

                        <section className="section_17" ref={scrollRef[11]}>
                            <h3>
                                <span>low voltage cut-off</span>
                                BATTERY PROTECTION INTEGRATED
                            </h3>
                            <p>FineVu is equipped with Battery Protection System.<br/>
                                Dashcam powers down when battery voltage falls below preset value.<br/>
                                Select your-car-specific power setting on FineVu CLOUD & Wi-Fi app to maximize both dashcam and car battery with a single tap.</p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_42.png" alt="low voltage cut-off"/>
                            </div>
                            <ul style={{marginTop: '30px'}}>
                                <li>* FineVu recommends changing the low voltage settings to ‘hybrid’ when using the ISG system.</li>
                            </ul>
                        </section>

                        <section className="section_18" ref={scrollRef[12]}>
                            <h3>
                                <span>MEMORY ALLOCATION</span>
                                EFFICIENT MEMORY MANAGEMENT
                            </h3>
                            <p>The memory allocation function enables efficient memory management<br/>
                                according to the driving pattern.</p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_43.png" alt="MEMORY ALLOCATION"/>
                            </div>
                            <ul style={{marginTop: '30px'}}>
                                <li>* The MicroSD card is formatted when changing the memory allocation.</li>
                                <li>* The memory format type is FAT32, and if the format type is different, the dash cam proceeds with formatting automatically.<br/>
                                    (After formatting, once you insert it into the device and supply it with power, the formatting will be in progress to set the memory.)
                                </li>
                            </ul>
                        </section>

                        <section className="section_19" ref={scrollRef[13]}>
                            <h3>
                                <span>CUSTOMIZING OSD PHRASES</span>
                                SYMBOLIC NAME ACCORDING TO USER’S TASTE
                            </h3>
                            <p>Users can change the wording of the On Screen Display(OSD) to user’s preference.<br/>
                                Up to 20 characters can be entered in English letters, numbers, and special characters.</p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_44.png" alt="CUSTOMIZING OSD PHRASES"/>
                            </div>
                            <ul style={{marginTop: '30px'}}>
                                <li>* OSD Phrases can be set up in the FineVu CLOUD & Wi-Fi app.</li>
                                <li>* Special characters are only available for `~!@$^&*()-_=+:;[]&lt;&gt;? (Spaces are not supported.)</li>
                            </ul>
                        </section>

                        <section className="section_20" ref={scrollRef[14]}>
                            <h3>
                                <span>FORMAT FREE 2.0</span>
                                ADVANCED FORMAT FREE TECHNOLOGY
                            </h3>
                            <p>Format Free 2.0 technology eliminates the needs of manual reformatting the micro SD memory card.<br/>
                                Also, it helps to extend memory card lifetime and improve reliability.</p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_45.png" alt="FORMAT FREE 2.0"/>
                            </div>
                        </section>

                        <section className="section_21">
                            <h3>
                                <span>FINEVU PC PLAYER</span>
                                THE OPTIMAL DASH CAM ANALYSIS PROGRAM,<br/>
                                FINEVU PLAYER 2.0
                            </h3>
                            <p>FineVu PC player is an easy-to-use PC software for FineVu dash cam.<br/>
                                You can playback, screenshot, enlarge the images with full resolution and<br/>
                                monitor the video records conveniently on your PC.</p>
                            <div className="imgBox">
                                <img src="/assets/images/product/gx11004k/FineVu_GX1100-4K_46.png" alt="FINEVU PC PLAYER"/>
                            </div>
                            <ul style={{marginTop: '30px'}}>
                                <li>* This feature can be used after installing FineVu Player program.</li>
                            </ul>
                        </section>
                    </div>

                    <div className={`description ${tabIndex === 2 ? 'active' : ''}`}>
                        <section>
                            <h3>Product Description</h3>
                            <div className="imgBox">
                                <img src="/assets/images/fineVu_GX1000_spec.png" alt="Product Description"/>
                            </div>
                        </section>
                    </div>

                    <div className={`specifications ${tabIndex === 4 ? 'active' : ''}`}>
                        <div className="tableWrap">
                            <table>
                                <thead>
                                <tr>
                                    <th>&nbsp;</th>
                                    <th>FineVu GX1100 4K</th>
                                    <th>Remark</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <th>Image Sensor</th>
                                    <td>
                                        8.46M pixels CMOS Image Sensor (1/2.8”)<br></br>
                                        2M pixels CMOS Image Sensor (1/2.9”)
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Resolution</th>
                                    <td>
                                        3840×2160P (Ultra HD)<br></br>
                                        1920×1080P (Full HD)
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Frames Per Second</th>
                                    <td>
                                        30fps
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                <th>Viewing Angle</th>
                                    <td>
                                        Front: 136°<br></br>
                                        Rear: 143°
                                    </td>
                                    <td>Diagonal</td>
                                </tr>
                                <tr>
                                    <th>Recording Mode</th>
                                    <td>
                                        Driving Recording (Standard, Impact Detection, Time Lapse)<br/>
                                        Manual Recording<br/>
                                        Parking Recording (Motion Detection, Impact Detection, Time Lapse, Power Saving Parking)
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Display</th>
                                    <td>Non-LCD</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Acceleration Sensor</th>
                                    <td>3-axis acceleration sensor</td>
                                    <td>+2g / -2g</td>
                                </tr>
                                <tr>
                                    <th>GPS</th>
                                    <td>Built-In</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Wi-Fi</th>
                                    <td>Built-In(dongle)</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Storage Capacity</th>
                                    <td>FineVu Micro SD Card (32GB ~ 128GB)</td>
                                    <td>Class 10 or above, SDXC support</td>
                                </tr>
                                <tr>
                                    <th>Battery</th>
                                    <td>Super capacitor</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>MIC</th>
                                    <td>Built-In</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Speaker</th>
                                    <td>Built-In</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Interface</th>
                                    <td>
                                        Power port (3.5Ø),
                                        Rear camera port (2.5Ø),
                                        Button (REC/MIC, Wi-Fi),
                                        BT + Wi-Fi port (USB A Type),
                                        Micro SD card slot,
                                        Power switch
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Security LED</th>
                                    <td>
                                        Front : White / Rear : White
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Input Power</th>
                                    <td>DC 12V~24V</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Power Consumption</th>
                                    <td>
                                        Parking Mode: 4.8W /
                                        Power Saving Parking Mode: 0.06W
                                    </td>
                                    <td>2CH, GPS OFF / Wi-Fi OFF</td>
                                </tr>
                                <tr>
                                    <th>High-Temperature Cut-Off</th>
                                    <td>AI Heat Monitoring</td>
                                    <td>During parking mode</td>
                                </tr>
                                <tr>
                                    <th>Low Voltage Cut-Off</th>
                                    <td>Supported</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Temperature</th>
                                    <td>
                                        Operation: -20°C ~ 70°C (-4°F ~ 158°F)<br></br>
                                        Storage: -30°C ~ 80°C (-22°F ~ 176°F)
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Size(WxDxH)</th>
                                    <td>
                                        Front: 96.6 × 71.7 × 26.5mm (3.8 × 2.8 × 1.0”)<br></br>
                                        Rear: 46.8 × 29.9 × 36.5mm (1.8 × 1.1 × 1.4”)
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Weight</th>
                                    <td>
                                        Front: 123g (4.3oz)<br></br>
                                        Rear: 28g (1.0oz)
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Language Supported</th>
                                    <td>English, Chinese (Simplified, Traditional), French, German, Arabic, Hebrew, Italian, Japanese, Malay, Polish, Russian, Spanish, Thai, Turkish, Vietnamese, Korean</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>Mobile Application</th>
                                    <td>FineVu Cloud & Wi-Fi App</td>
                                    <td>Android, iOS</td>
                                </tr>
                                <tr>
                                    <th>PC Viewer</th>
                                    <td>FineVu Player 2.0</td>
                                    <td>Windows, MAC</td>
                                </tr>
                                <tr>
                                    <th>Features</th>
                                    <td>
                                        Auto Night Vision,
                                        AI Heat Monitoring,
                                        Power Saving Parking Mode,
                                        Time Lapse,
                                        ADAS PLUS (FVMA & LDWS),
                                        Speed Camera Alert,
                                        Low Voltage Cut-Off,
                                    </td>
                                    <td>ADAS and Speed Camera Alert requires GPS reception</td>
                                </tr>
                                <tr>
                                    <th>Certification</th>
                                    <td className="imgArea">
                                        <div>
                                            <img src="/assets/images/table_certification.png" alt="Certification"/>
                                        </div>
                                    </td>
                                    <td></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {tabIndex === 5 ? <ManualBox/> : ''}
                </div>
            </div>
        </div>

        </>
    )
}
